export default __webpack_public_path__ + "static/media/litho-demo-coming-soon.eab540bb.jpg";